import { render } from "./GridCampaniiMarketing.vue?vue&type=template&id=a6edadc2&scoped=true&ts=true"
import script from "./GridCampaniiMarketing.vue?vue&type=script&lang=ts"
export * from "./GridCampaniiMarketing.vue?vue&type=script&lang=ts"

import "./GridCampaniiMarketing.vue?vue&type=style&index=0&id=a6edadc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6edadc2"]])

export default __exports__